import * as React from "react"
import { graphql } from "gatsby"
import { GatsbyImage, withArtDirection } from "gatsby-plugin-image"
import { PropTypes } from "prop-types"

import theme from "../gatsby-plugin-theme-ui"
import { NavHeader } from "../components/NavHeader"
import { Layout } from "../components/Layout"
import { AllPages } from "../components/AllPages"
import { About } from "../components/About"
import { Link } from "../components/Link"
import "./HomePage.css"

const HomePage = ({ data, pageContext }) => {
  const mainImage = withArtDirection(data.desktop.gatsbyImageData, [
    {
      media: `(max-width: ${theme.breakpointWidths.sm})`,
      image: data.mobilePortrait.gatsbyImageData,
    },
  ])
  return (
    <Layout shouldIncludeNavheader={false}>
      <Link to="/#read" className="main-image-link">
        <GatsbyImage
          className="main-image"
          imgStyle={{ objectPosition: "top" }}
          image={mainImage}
          alt="I went to Japan cover art"
        />
      </Link>
      <NavHeader />
      <AllPages pages={pageContext.comicPages} />
      <About />
    </Layout>
  )
}
HomePage.propTypes = {
  data: PropTypes.shape({
    desktop: PropTypes.shape({
      gatsbyImageData: PropTypes.object,
    }),
    mobilePortrait: PropTypes.shape({
      gatsbyImageData: PropTypes.object,
    }),
  }),
  pageContext: PropTypes.shape({
    comicPages: PropTypes.arrayOf(
      PropTypes.shape({
        page_number: PropTypes.number,
        slug: PropTypes.string,
        imageData: PropTypes.object,
      })
    ),
  }),
}

export default HomePage

export const query = graphql`
  query mainImage {
    desktop: imgixImage(url: "i-went-to-japan/pages/cover-2.png") {
      gatsbyImageData(width: 1920)
    }
    mobilePortrait: imgixImage(url: "i-went-to-japan/mobile-cover-2.png") {
      gatsbyImageData(
        width: 500
        height: 800
        imgixParams: { fit: "crop", crop: "top" }
      )
    }
  }
`
